import { Student } from 'src/app/_models/student';
import { Guardian } from 'src/app/_models/guardian';
import { DataUtilService } from 'src/app/_services/data-util.service';
import { MessageService } from './../../../_services/message.service';
import { AuthService } from 'src/app/_services/auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-messaging-combined-tab',
  templateUrl: './student-messaging-combined-tab.component.html',
  styleUrls: ['./student-messaging-combined-tab.component.css']
})
export class StudentMessagingCombinedTabComponent implements OnInit {
  messagesSent=[]
  messagesReceived=[]
  guardian = new Guardian()
  student = new Student()
  userId=0
  dtOptions: any = {};
  constructor(
    public authService:AuthService,
    private messageService:MessageService
  ) { }

  ngOnInit(): void {
    this.userId=this.authService.gatePass.getValue().user_id
    this.messageService.getMessages(this.userId).subscribe(
      val=>{
        this.messagesReceived=val['messagesReceived']
        this.messagesSent=val['messagesSent']
      }
    )
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: false,
      info    : false
     };

    }


}
